export const API_ROOT = 'https://api-edge-dev.inherinext.compassbioinfo.jp/'
// export const API_ROOT = 'https://server-edge.inherinext.jp/'

export const WS_ROOT = 'wss://api-edge-dev.inherinext.compassbioinfo.jp/cable'
// export const WS_ROOT = 'wss://server-edge.inherinext.jp/cable'



// WEBPACK FOOTER //
// ./src/api/config.js